export type AgentHubItem = {
  id: string;
  href: `/ah/${string}`;
  labelKey: string;
  beta?: boolean;
  requiresProductUnlock?: boolean;
};

export const AGENT_HUB_ITEMS: AgentHubItem[] = [
  {
    id: "risk-assessment",
    href: "/ah/risk-assessment",
    labelKey: "sidebar.risk_assessment",
  },
  {
    id: "object-risk-assessment",
    href: "/ah/object-risk-assessment",
    labelKey: "sidebar.object_risk_assessment",
    beta: true,
  },
  {
    id: "accident-search",
    href: "/ah/accident-search",
    labelKey: "sidebar.accident_search",
  },
  {
    id: "legal-search",
    href: "/ah/legal-search",
    labelKey: "sidebar.legal_search",
  },
  {
    id: "conceptual-estimate",
    href: "/ah/conceptual-estimate",
    labelKey: "sidebar.conceptual_estimate",
    beta: true,
    requiresProductUnlock: true,
  },
];

export const AGENT_HUB_AGENT_IDS = new Set([
  ...AGENT_HUB_ITEMS.map((item) => item.id),
  "demolition-risk-assessment",
]);
const AGENT_HUB_ITEM_IDS = new Set(AGENT_HUB_ITEMS.map((item) => item.id));

export const CHAT_HISTORY_PATH = "/c";
export const PUBLIC_SESSION_ID_PATTERN = /^[0-9a-f]{32}$/;

export function isAgentHubAgent(agentId: string): boolean {
  return AGENT_HUB_AGENT_IDS.has(agentId);
}

export function isAgentHubItemId(value: unknown): value is string {
  return typeof value === "string" && AGENT_HUB_ITEM_IDS.has(value);
}

export function isPublicSessionId(value: unknown): value is string {
  return typeof value === "string" && PUBLIC_SESSION_ID_PATTERN.test(value);
}

export function getAgentPath(agentId: string): string {
  const prefix = isAgentHubAgent(agentId) ? "/ah" : "/c";
  return `${prefix}/${encodeURIComponent(agentId)}`;
}

export function getAgentSessionHref(
  agentId: string,
  sessionId: string,
): string {
  return `${getAgentPath(agentId)}?session=${encodeURIComponent(sessionId)}`;
}

export function withRouteSearchParams(
  path: string,
  query: Record<string, string | string[] | undefined>,
): string {
  const serialized = new URLSearchParams();
  for (const [key, value] of Object.entries(query)) {
    if (Array.isArray(value)) {
      value.forEach((item) => serialized.append(key, item));
    } else if (value !== undefined) {
      serialized.set(key, value);
    }
  }
  return serialized.size ? `${path}?${serialized.toString()}` : path;
}

export const AGENT_LABEL_KEYS = AGENT_HUB_ITEMS.reduce<Record<string, string>>(
  (acc, item) => {
    acc[item.id] = item.labelKey;
    return acc;
  },
  {},
);

// Past demolition sessions keep their labels and legacy URLs even though the
// separate hub entry now opens inside the unified risk-assessment workspace.
AGENT_LABEL_KEYS["demolition-risk-assessment"] =
  "sidebar.demolition_risk_assessment";
